// extracted by mini-css-extract-plugin
export default {"base":"vp_Z8BYE","colorContrast":"vp_yeCK2","colorPrimary":"vp_HWXV7"};